import { api } from '../api';

export const get = (id?: number) => api.get('/iso', { params: { id }, responseType: 'blob' });

export const generate = (id?: number) => api.post('/iso/generate', null, { params: { id } });

export const check = (id?: number) => api.get('/iso/status', { params: { id } });
